import { useWidgetData } from '../useWidgetData'

import { RevenueSplitModel } from '../../../types/court/court'
import { ReportInterval } from '../../../types/report/report'
import { createReportQuery } from '../../../utils/reportUtils'

export const useRevenueSplitWidget = (interval: ReportInterval) =>
  useWidgetData<RevenueSplitModel>(
    `revenue-split?${createReportQuery(interval)}`
  )
